import { ESTADO_SOLICITUD, TIPO_SOLICITUD } from "../utils/Constants";
import { formatFecha, momentFecha } from "../utils/funciones";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import moment from "moment";

const exportarJsonExcel = require("js-export-excel");

export const useExcel = () => {
  const fecha = new Date();

  const generarExcel = async props => {
    const { arrData, arrHeaders, sheetHeadersArr, sheetColumnWidth, fileName = 'tabla' } = props;

    let sheetConfig = {
      fileName: `${fileName}__${momentFecha(fecha)}__${moment(fecha).format("HHmm")}`,
      datas: [
        {
          sheetHeader: sheetHeadersArr,
          sheetData: arrData,
          sheetName: `hoja1`,
          sheetFilter: arrHeaders,
          columnWidths: sheetColumnWidth,
        },
      ],
    }

    let excelFile = new exportarJsonExcel(sheetConfig);
    await excelFile.saveExcel();
  }


  const returnHojaProps = (props) => {
    const { arr } = props;

    const titulosCabecera = [
      "ID HISTORIAL",
      "ID SOLICITUD",
      "ID ESTADO SOLICITUD",
      "OBSERVACIONES",
      "FECHA CREACION"
    ];

    return arr.map(el => {
      return ({
        sheetHeader: titulosCabecera,
        sheetData: el.historiales,
        sheetName: `Solicitud ${el.historiales[0].id}`,
        sheetFilter: Object.keys(el.historiales[0]),
        columnWidths: [5, 5, 8, 30, 7],
      })
    });
  }

  const generarExcelHistorial = async (props) => {
    const { arr, nombreArchivo } = props;

    try {
      const hojas = returnHojaProps({ arr: arr });

      let excelProps = {
        fileName: `${nombreArchivo}__${momentFecha(fecha)}__${moment(fecha).format("HHmm")}`,
        datas: hojas
      }

      let excelFile = new exportarJsonExcel(excelProps);
      await excelFile.saveExcel();
    } catch (error) {
      console.log(error);
    }
  }

  function conservarPrimerEstado(array) {
    const vistos = new Set();
    const resultado = [];

    for (let i = array.length - 1; i >= 0; i--) {
      const item = array[i];
      if (!vistos.has(item.id_estado_solicitud)) {
        vistos.add(item.id_estado_solicitud);
        resultado.push(item);
      }
    }

    return resultado;
  }

  const retornoFechaRRHH = (arr) => {
    const uno = arr.filter((el) => [4, 5, 8].includes(el.id_estado_solicitud));
    if (uno.length > 0 && uno[0].created_at) {
      const parts = uno[0].created_at.split(' ');
      return `${formatFecha(parts[0])} ${parts[1] || ''}`;
    }
    return '---';
  }

  const retornoFechaAdminDestino = (arr) => {
    const uno = arr.filter((el) => [6, 11].includes(el.id_estado_solicitud));
    if (uno.length > 0 && uno[0].created_at) {
      const parts = uno[0].created_at.split(' ');
      return `${formatFecha(parts[0])} ${parts[1] || ''}`;
    }
    return '---';
  }

  const retornoFechaJefeDeZona = (arr) => {
    const uno = arr.filter((el) => [2, 3, 10].includes(el.id_estado_solicitud));
    if (uno.length > 0 && uno[0].created_at) {
      const parts = uno[0].created_at.split(' ');
      return `${formatFecha(parts[0])} ${parts[1] || ''}`;
    }
    return '---';
  }

  const devolver_rrhhResolutor = (arr) => {
    const uno = arr.filter((el) => [4, 5].includes(el.id_estado_solicitud) && el.id_creador);
    return (uno.length > 0 && uno[0].id_creador) ? uno[0].id_creador : '---';
  }

  function agregarPrimeraHoja(workbook, arr) {
    const nombrePrimeraHoja = "Historial Solicitudes";
    const primeraHoja = workbook.addWorksheet(nombrePrimeraHoja);

    const columnasPrimeraPagina = [
      { header: 'ID SOLICITUD', key: 'id', width: 12 },
      { header: 'ID PERSONA', key: 'id_persona', width: 11 },
      { header: 'NOMBRE', key: 'nombre', width: 40 },
      { header: 'IDENTIFICACION', key: 'identificacion', width: 16 },
      { header: 'NOMBRE CARGO ACTUAL', key: 'nombre_cargo_actual', width: 40 },
      { header: 'INSTALACION ACTUAL', key: 'instalacion_actual', width: 30 },
      { header: 'TIPO SOLICITUD', key: 'id_tipo_solicitud', width: 24 },
      { header: 'NUEVO CARGO', key: 'nombre_nuevo_cargo', width: 30 },
      { header: 'INSTALACION DE DESTINO', key: 'nombre_instalacion_destino', width: 30 },
      { header: 'ESTADO SOLICITUD', key: 'id_estado_solicitud', width: 60 },
      { header: 'FECHA INICIO CAMBIO', key: 'fecha_inicio_cambio', width: 20 },
      { header: 'COD SUB DIVISION', key: 'moes_cod_sub_division', width: 20 },
      { header: 'ADMIN SOLICITANTE', key: 'cod_sap_administrador', width: 19 },
      { header: 'FECHA SOLICITUD', key: 'created_at', width: 22 },
      { header: 'SAP JEFE DE ZONA', key: 'cod_sap_jefe', width: 19 },
      { header: 'FECHA JEFE ZONA RESPUESTA', key: 'fecha_jefe_zona_respuesta', width: 22 },
      { header: 'SAP RRHH DESIGNADO', key: 'cod_sap_rrhh_responsable', width: 30, },
      
      { header: 'SAP RRHH RESOLUTOR', key: 'cod_sap_rrhh_responsable_resolutor', width: 30, },
      { header: 'RRHH RESOLUTOR FECHA', key: 'fecha_recursos_humanos_respuesta', width: 22 },
      { header: 'SAP ADMIN DESTINO', key: 'cod_sap_administrador_destino', width: 19 },
      { header: 'ADMIN DESTINO FECHA', key: 'admin_destino_fecha', width: 22 },
    ];

    primeraHoja.columns = columnasPrimeraPagina;

    arr.forEach((row) => {
      const fila = {
        ...row,
        id_tipo_solicitud: TIPO_SOLICITUD[row.id_tipo_solicitud],
        id_estado_solicitud: ESTADO_SOLICITUD[row.id_estado_solicitud],
        fecha_inicio_cambio: formatFecha(row.fecha_inicio_cambio),
        identificacion: row.persona.identificacion,
        nombre: `${row.persona.nombre} ${row.persona.apellido_pat} ${row.persona.apellido_mat}`,
        nombre_cargo_actual: row.nombre_cargo_actual?.split("|")[1] || "---",
        created_at: row.created_at ? `${formatFecha(row.created_at.split(' ')[0])} ${row.created_at.split(' ')[1] || ''}` : '---',

        fecha_jefe_zona_respuesta: retornoFechaJefeDeZona(conservarPrimerEstado(row.historiales)),
        fecha_recursos_humanos_respuesta: retornoFechaRRHH(conservarPrimerEstado(row.historiales)),
        cod_sap_administrador_destino: row.cod_sap_administrador_destino || '---',
        admin_destino_fecha: retornoFechaAdminDestino(conservarPrimerEstado(row.historiales)),
        cod_sap_jefe: [3].includes(row.id_tipo_solicitud) ? row.cod_sap_jefe_unidad_destino : row.cod_sap_jefe,
        cod_sap_rrhh_responsable_resolutor: devolver_rrhhResolutor(row.historiales),
      }

      primeraHoja.addRow(fila);
    });
  }

  function agregarHojasDetalle(workbook, arr) {
    const columnas = [
      { header: 'ID HISTORIAL', key: 'id', width: 15 },
      { header: 'ID SOLICITUD', key: 'id_solicitud', width: 15 },
      { header: 'ID ESTADO SOLICITUD', key: 'id_estado_solicitud', width: 20 },
      { header: 'OBSERVACIONES', key: 'observaciones', width: 80 },
      { header: 'FECHA CREACION', key: 'created_at', width: 20 },
    ];

    const arrHistorial = arr.map(el => ({ [el.id]: el.historiales }));

    for (const obj of arrHistorial) {
      const nombreHoja = Object.keys(obj)[0];
      const filas = Object.values(obj)[0];
      const hoja = workbook.addWorksheet(nombreHoja);
      hoja.columns = columnas;

      filas.forEach(row => {
        hoja.addRow(row);
      });
    }
  }

  async function descargarWorkbook(workbook, nombreArchivo) {
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, `${nombreArchivo}__${momentFecha(fecha)}__${moment(fecha).format("HHmm")}.xlsx`);
  }

  const generarExcelNuevo = async ({ arr, nombreArchivo }) => {
    const workbook = new ExcelJS.Workbook();
    agregarPrimeraHoja(workbook, arr);
    agregarHojasDetalle(workbook, arr);
    await descargarWorkbook(workbook, nombreArchivo);
  }

  const generarExcelPrimeraHoja = async ({ arr, nombreArchivo }) => {
    const workbook = new ExcelJS.Workbook();
    agregarPrimeraHoja(workbook, arr);
    await descargarWorkbook(workbook, nombreArchivo);
  }

  const generarExcelHojasDetalle = async ({ arr, nombreArchivo }) => {
    const workbook = new ExcelJS.Workbook();
    agregarHojasDetalle(workbook, arr);
    await descargarWorkbook(workbook, nombreArchivo);
  }

  return {
    generarExcel, generarExcelHistorial, generarExcelNuevo, generarExcelPrimeraHoja, generarExcelHojasDetalle
  }
}